import { libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setLoadedDoorRange = (doorRange: libTypes.SupplierComputedProduct[]) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.currentValues.supplierDoorRange = doorRange;
        })
    });
};